import { INITIAL_DASHBOARD_DATA } from "contexts/DashboardContext";
import { DashboardProps } from "types/GlobalData";
import { getValidDashboards } from "util/dashboardGroups";

export function getCurrentDashboardProps(currentId: string, dashboards: unknown): DashboardProps {
  return (
    getValidDashboards(dashboards).find((dashboard) => dashboard.id === currentId) ??
    INITIAL_DASHBOARD_DATA[0]
  );
}
